/* eslint-disable no-plusplus */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */

import { fabric } from 'fabric';
import { generateId } from '../../utils';
import { FABRIC_CUSTOM_OBJECT, HEADER_CONTAINER, TITLE_CONTAINER } from '../../utils/constants';
import { EPS } from './SwimLaneHorizontal';

const createComponents = (root) => {
  const rect = new fabric.Rect({
    ...root.headerStyle,
    top: -root.height / 2 - root.headerStyle.strokeWidth / 2,
    left: -root.width / 2 - root.headerStyle.strokeWidth / 2,
    objectCaching: false,
  });
  const text = new fabric.Textbox(root.label, {
    ...root.textStyle,
    top: -root.height / 2 + root.headerHeight / 2,
    left: 0,
    width: root.width - EPS * 2,
    objectCaching: false,
  });
  root.set({ objectCaching: false });
  return { rect, text };
};

fabric.SwimLaneVertical = fabric.util.createClass(fabric.Rect, {
  type: FABRIC_CUSTOM_OBJECT.swimLaneVertical,
  initialize(options) {
    this.callSuper('initialize', options);
    this.set('name', 'Vertical Swim Lane');
    this.set('isContainer', true);
    this.set('headerHeight', options.headerHeight);
    this.set('textStyle', { ...options.textStyle });
    this.set('headerStyle', { ...options.headerStyle, height: this.headerHeight, width: this.width });
    this.set('id', options.id || generateId());
    this.set('type', FABRIC_CUSTOM_OBJECT.swimLaneVertical);
    this.setControlsVisibility({
      mtr: false,
    });
    this.on('scaling', this.onScaling);
  },
  onScaling: function () {
    const width = this.scaleX * this.width;
    const height = this.scaleY * this.height;
    this.set({
      width,
      height,
      scaleX: 1,
      scaleY: 1,
      flipX: false,
      flipY: false,
    });
  },
  updateClipPath: function () {
    const clipPathObj = new fabric.Rect({
      width: this.width + this.strokeWidth,
      height: this.height + this.strokeWidth,
      left: -this.width / 2 - this.strokeWidth / 2,
      top: -this.height / 2 - this.strokeWidth / 2,
      strokeWidth: 0,
    });
    this.noScaleCache = false;
    this.clipPath = clipPathObj;
  },
  updateRectComponent(rect) {
    rect.set({
      width: this.width,
      stroke: this.stroke,
      strokeDashArray: this.strokeDashArray,
      rx: this.rx,
      ry: this.ry,
    });
    this.set({ headerStyle: { ...this.headerStyle, width: this.width } });
  },
  toObject() {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      id: this.get('id'),
      isContainer: this.get('isContainer') || true,
      headerHeight: this.get('headerHeight'),
      headerStyle: this.get('headerStyle'),
      textStyle: this.get('textStyle'),
    });
  },
  toSVG() {
    this.updateClipPath();
    const { rect, text } = createComponents(this);
    this.updateRectComponent(rect);
    return this.callSuper('toSVG') + rect.toSVG() + text.toSVG();
  },
  _render(ctx) {
    this.updateClipPath();
    const { rect, text } = createComponents(this);
    this.updateRectComponent(rect);
    this.callSuper('_render', ctx);
    rect.render(ctx);
    text.render(ctx);
  },
});

fabric.SwimLaneVertical.fromObject = function (options, callback) {
  return callback(new fabric.SwimLaneVertical(options));
};

window.fabric.SwimLaneVertical = fabric.SwimLaneVertical;

export default fabric.SwimLaneVertical;

export function createCustomObj(options) {
  if (!options) {
    const rect = new fabric.SwimLaneVertical({
      name: 'Vertical Swim Lane',
      width: 300,
      height: 400,
      headerHeight: 80,
      stroke: '#ed9c3a',
      strokeWidth: 2,
      fill: 'transparent',
      label: 'Swim Lane',
      headerStyle: {
        name: HEADER_CONTAINER,
        width: 300,
        height: 80,
        stroke: '#ed9c3a',
        strokeWidth: 2,
        fill: 'transparent',
        lockMovementX: true,
        lockMovementY: true,
      },
      textStyle: {
        name: TITLE_CONTAINER,
        text: 'Swim Lane',
        fontSize: 40,
        fill: '#3f75cc',
        fontFamily: 'Helvetica',
        backgroundColor: 'transparent',
        textAlign: 'center',
        originX: 'center',
        originY: 'center',
        fontWeight: '', // bold
        fontStyle: '', // italic
        lockMovementX: true,
        lockMovementY: true,
      },
      id: generateId(),
    });
    return rect;
  }

  const {
    top,
    left,
    width,
    height,
    headerHeight,
    stroke,
    strokeWidth,
    fill,
    label,
    rx,
    ry,
    textStyle,
    headerStyle,
    id,
  } = options;
  const rect = new fabric.SwimLaneVertical({
    top,
    left,
    width,
    height,
    headerHeight,
    stroke,
    strokeWidth,
    fill,
    label,
    rx,
    ry,
    textStyle,
    headerStyle,
    id,
  });
  return rect;
}
